/**
 * Define the chatbox widget configuration entity.
 */
export class WidgetConfigEntity {

    /**
     * Constructor of WidgetConfigEntity
     * 
     * @param botKey - The associated bot key
     * @param params - The server and the integration parameters (object generated dynamically according to the provided config)
     * @param suggestedQuestions - The list of suggested questions to be used in autocomplete mode
     */
    constructor(public botKey: string,
                public params: Map<string, any>,
                public suggestedQuestions?: string[]) {}
}
